import { Form, message } from 'antd';
import axios from 'axios';
import moment from 'moment';
import { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import PPPageHeader from '../../components/pageHeader/PPPageHeader';
import SaleForm from './SaleForm';

const ModalEditSale = () => {
  const location = useLocation();
  const history = useHistory();
  const productDetail = location?.state?.product ?? {};
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  const { price, title, baseSku, productSku, category, saleItem } = productDetail;

  const startAt = saleItem?.startAt ? moment(saleItem.startAt) : null;
  const endAt = saleItem?.endAt ? moment(saleItem.endAt) : null;

  const formInitialVals = {
    title,
    ...(saleItem ?? {}),
    // Хуучин хямдралд үндсэн үнэ бичигдээгүй байвал барааны үнээр нөхнө
    priceBeforeSale: saleItem?.priceBeforeSale ?? price,
    dateRange: [startAt, endAt],
  };

  /** Хямдралын таб руу буцна — засварласан хямдрал тэндээ харагдана */
  const saleTab = {
    pathname: `/merchant/products/${productDetail?._id}`,
    search: '?tab=sale',
  };

  const onFinish = async (values) => {
    const body = {
      ...values,
      // Сонгосон дуусах өдрийн 23:59 хүртэл хямдрал үргэлжилнэ
      startAt: values.dateRange?.[0]?.clone().startOf('day'),
      endAt: values.dateRange?.[1]?.clone().endOf('day'),
      salePercent: 0,
      fromThirdParty: false,
      baseSku,
      productSku,
      category,
    };

    setSubmitting(true);
    try {
      const { data } = await axios.post(`/api/v1.0/productSale/${saleItem?._id}`, body);

      if (data.statusCode === 200) {
        message.success('Хямдрал амжилттай засагдлаа');
        form.resetFields();
        history.push(saleTab);
      }
    } catch (error) {
      // Алдааны мэдэгдлийг axios interceptor (App.js) аль хэдийн гаргасан
      console.error('Update product sale error: ', error);
    } finally {
      setSubmitting(false);
    }
  };

  const routes = [
    {
      to: { pathname: '/merchant/product/list' },
      breadcrumbName: 'Бараа',
    },
    {
      to: saleTab,
      breadcrumbName: 'Нэгж бараа',
    },
    {
      breadcrumbName: 'Хямдрал засах',
    },
  ];

  return (
    <>
      <PPPageHeader
        title="Хямдрал засах"
        breadcrumb={{ routes }}
        onBack={() => history.push(saleTab)}
      />

      <SaleForm
        form={form}
        id={productDetail?._id}
        product={productDetail}
        onFinish={onFinish}
        submitting={submitting}
        submitText="Хямдрал засах"
        initialValues={formInitialVals}
      />
    </>
  );
};

export default ModalEditSale;
